import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { LoginForm } from '../components/LoginForm';
import { useAuth } from '../context';

export function LoginPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Если пользователь уже авторизован, перенаправляем на dashboard
  React.useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  const handleLoginSuccess = () => {
    // После успешного входа перенаправляем сразу на dashboard
    navigate('/dashboard', { replace: true });
  };

  const handleSwitchToRegister = () => {
    navigate('/register');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <LoginForm 
          onSuccess={handleLoginSuccess}
          onSwitchToRegister={handleSwitchToRegister}
        />
        
        <div className="mt-6 text-center text-sm text-muted-foreground">
          <Link 
            to="/" 
            className="hover:text-primary transition-colors"
          >
            ← Вернуться на главную
          </Link>
        </div>
      </div>
    </div>
  );
}
